export const handleScrollToSection = (target) => {
    const element = document.getElementById(target);
    if (element) {
        element.scrollIntoView({behavior: 'smooth', block: 'start'});
    }
};
